export const getAllTemplatesExchangeConfig = () => ({
  url: `/aura_template_overrides`,
});

export const getTemplatesExchangeByIdConfig = (id) => ({
  url: `/aura_template_overrides/${id}`,
});

export const getTemplateConfig = () => ({
  url: `/get_template_overrides`,
});

export const getDotPhraseByIdConfig = (id) => ({
  url: `/get_dot_phraseoverrides_detail/${id}`,
});

export const getDotPhraseConfig = () => ({
  url: `/get_dot_phrase`,
});

export const getInsightHealthTemplatesListConfig = () => ({
  url: `/insight_health_templates`,
});

export const getInsightHealthTemplatesByIdConfig = (id) => ({
  url: `/insight_health_templates/${id}`,
});

export const assignInsightHealthTemplatesConfig = () => ({
  url: `/insight_health_templates/assign`,
});
